import { render, staticRenderFns } from "./BlocoInserirDadosRelatorio.vue?vue&type=template&id=a51127f6&lang=pug"
import script from "./BlocoInserirDadosRelatorio.vue?vue&type=script&lang=js"
export * from "./BlocoInserirDadosRelatorio.vue?vue&type=script&lang=js"
import style0 from "./BlocoInserirDadosRelatorio.vue?vue&type=style&index=0&id=a51127f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports